import type { Meta, StoryObj } from "@storybook/react";

import type { PersonalSafetyPlanProps } from "@/ui/components/profile/safetyPlan/PersonalSafetyPlan";
import PersonalSafetyPlan from "@/ui/components/profile/safetyPlan/PersonalSafetyPlan";
import ScreenContainer from "@/ui/layout/ScreenContainer";

const StoryMeta: Meta<PersonalSafetyPlanProps> = {
  title: "Components/Safety Plan/Personal Safety Plan",
  argTypes: {
    completedOn: { control: "text" },
    copingSkills: { control: "object" },
    imminentRiskOfSelfHarm: { control: "text" },
    localEmsPhone: { control: "text" },
    mostImportantReasons: { control: "text" },
    otherWarningSigns: { control: "text" },
    supportPeople: { control: "object" },
    title: { control: "text" },
    warningSigns: { control: "object" },
  },
  args: {
    completedOn: "Completed on May 17, 2023",
    copingSkills: [
      "Mindfulness (e.g., taking deep breaths) - Taking deep breaths",
      "Mindfulness (e.g., taking deep breaths) - Self-compassion",
      "Distraction (e.g., play video game) - Taking a walks outside",
    ],
    imminentRiskOfSelfHarm:
      "To immediately take a walk and consider calling a support if needed. Remind myself that time will help. Just breath and take time",
    localEmsPhone: "(626) 555-6431",
    mostImportantReasons:
      "I have friends and family who love and value me. There's so much more joy in life to experience",
    otherWarningSigns: "Lethargy, loss of appetite",
    supportPeople: [
      { Name: "Izzy", Phone: "(012) 345-6789" },
      { Name: "Mary", Phone: "(987) 654-3210" },
      { Name: "James", Phone: "(191) 282-3734" },
    ],
    title: "Olivia's safety plan",
    warningSigns: [
      "I bottle up and don't share what's on my mind",
      "I seem emotionless and force smiles",
      "I miss appointments and seem disengaged",
    ],
  },
  component: PersonalSafetyPlan,
  render: (props: PersonalSafetyPlanProps) => (
    <ScreenContainer isScrollView>
      <PersonalSafetyPlan {...props} />
    </ScreenContainer>
  ),
};

type Story = StoryObj<PersonalSafetyPlanProps>;

const Primary: Story = {};

export { Primary };
export default StoryMeta;
